import { FilterItem, FilterTypes } from '@shared/models/filters';
import {
  appDatePresets,
  appQuotesPresets,
  appStrings,
  creditsOptions,
  eventDayOptions,
  eventTypeOptions,
  guestNumberOptions,
  requestAgeOptions,
  requestTypeOptions
} from '../../../app.config';

export const REQUEST_FILTERS: FilterItem[] = [
  {
    id: 'filter_serviceUuids',
    name: 'Services',
    description: appStrings.filters.filter_based_on_services,
    icon: 'ate-tag-v2',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: [],
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_distance',
    name: 'Distance from event',
    description: appStrings.filters.filter_based_on_location,
    icon: 'ate-location-pin-v2',
    type: FilterTypes.SELECT_SINGLE,
    active: true,
    options: [],
    options_selected: 0,
    filters_applied_message: 'Any',
    data: null
  },
  {
    id: 'filter_dates',
    name: 'Date of event',
    description: null,
    icon: 'ate-calendar-v2',
    type: FilterTypes.DATERANGE_PICKER,
    active: true,
    options: appDatePresets,
    options_selected: 0,
    filters_applied_message: 'Any',
    data: null,
    min_date: new Date()
  },
  {
    id: 'filter_eventDay',
    name: 'Day of event',
    description: appStrings.filters.filter_based_on_event_day,
    icon: 'ate-calendar-v2',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: eventDayOptions,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_quotes',
    name: 'Number of quotes',
    description: appStrings.filters.filter_based_on_existing_quotes,
    icon: 'ate-document',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: appQuotesPresets,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_eventType',
    name: 'Event Types',
    description: appStrings.filters.filter_based_on_event_types,
    icon: 'ate-birthday-cake',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: eventTypeOptions,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_requestType',
    name: 'Request Types',
    description: appStrings.filters.filter_based_on_request_types,
    help_link: appStrings.filters.help_difference_request_types,
    icon: 'ate-send-circle',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: requestTypeOptions,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_request_age',
    name: 'Request live for',
    description: appStrings.filters.filter_based_on_request_age,
    icon: 'ate-countdown-4-v2',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: requestAgeOptions,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_request_uniGuests',
    name: 'Number of guests',
    description: appStrings.filters.filter_based_on_request_uniGuests,
    icon: 'ate-guests',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: guestNumberOptions,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_request_credits',
    name: 'Credits required',
    description: appStrings.filters.filter_based_on_credits,
    icon: 'ate-plus-circle',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: creditsOptions,
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_search',
    name: 'Search',
    type: FilterTypes.SEARCH,
    active: false,
    options: null,
    options_selected: 0,
    value: ''
  }
];
